import { Trans, useTranslation } from "react-i18next";

const Policy = () => {
  const { i18n } = useTranslation();

  return (
    <p
      key={i18n.language}
      className="text-[0.8125rem] leading-[1rem] text-section-header-text px-4 text-center tracking-tighter"
    >
      <Trans
        i18nKey="settings.policy"
        components={{
          terms: (
            <a
              href="/docs/Terms_of_Use_Complete.pdf"
              target="_blank"
              className="text-link"
            />
          ),
          privacy: (
            <a
              href="/docs/Privacy_Policy.pdf"
              target="_blank"
              className="text-link"
            />
          ),
          cookies: (
            <a
              href="/docs/Cookies_Policy.pdf"
              target="_blank"
              className="text-link"
            />
          ),
        }}
      />
    </p>
  );
};

export default Policy;
